import { about } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">品牌介绍</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">关于我们</h2>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            {about.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 last:mb-0">{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-6 mt-8">
            {about.stats.map((stat, idx) => (
              <div key={idx} className="text-center p-4 md:p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="text-xl md:text-3xl font-bold text-accent-600 font-heading mb-1">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}